import dayjs from 'dayjs'

type Format = 'YYYY/MM/DD' | 'YYYY/MM/DD HH:mm'

export const formatDate = (date: string, format: Format = 'YYYY/MM/DD') => {
  return dayjs(date).locale('ja').format(format)
}

export const lastUpdatedLabel = (date?: string | null) => {
  if (!date) {
    return ''
  }

  const now = dayjs()
  const targetDate = dayjs(date)
  const diffInMinutes = now.diff(targetDate, 'minute')
  const diffInHours = now.diff(targetDate, 'hour')
  const diffInDays = now.diff(targetDate, 'day')
  const diffInWeeks = now.diff(targetDate, 'week')
  const diffInMonths = now.diff(targetDate, 'month')
  const diffInYears = now.diff(targetDate, 'year')

  if (diffInMinutes < 60) {
    return `${diffInMinutes}分前`
  } else if (diffInHours < 24) {
    return `${diffInHours}時間前`
  } else if (diffInDays < 7) {
    return `${diffInDays}日前`
  } else if (diffInDays < 28) {
    return `${diffInWeeks}週間前`
  } else if (diffInMonths < 1) {
    return `4週間前`
  } else if (diffInMonths < 12) {
    return `${diffInMonths}ヶ月前`
  } else {
    return `${diffInYears}年前`
  }
}
